'use strict';

function EdictController($rootScope, $scope, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService) {
  var self = this;

  this.getEdict = function () {
    var contractId = dataHolderFactory.getSavedContractDetails().id;
    usSpinnerService.spin('spinner-1');
    dataRequestService.getEdict(contractId).then(function (result) {
      usSpinnerService.stop('spinner-1');
      $scope.edictViewControl.edict = result;
    }, function (error) {
      usSpinnerService.stop('spinner-1');
      console.log(error);
    });
  };

  $scope.initEdictController = function () {
    $scope.edictViewControl = objectMakerFactory.viewObjectControlForEdict();
    self.getEdict();
  };

  $scope.restoreViewControl = function () {
    $rootScope.appControl.showEdict = false;
  };
}

EdictController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService']
export default EdictController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/edictController.js